import React from 'react';
import { BrowserRouter as Router, Routes, Route,Switch } from 'react-router-dom';
import { useState, useEffect} from 'react';
import { configData } from "./config";
import { AuthProvider } from './components/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Login from './components/Login';
import AgencyLogin from './components/AgencyLogin';
import Footer from './components/Footer';
import CartApp from './components/CartPage';
import Post from './components/Post';
import ApplicationForm from './components/Application';
import Form from './components/Form';
import RequestForm from './components/RequestForm';
import TalkwithLynn from './components/TalkwithLynn';
import CoursePay from './components/CoursePay';
import CheckoutPage from './components/CheckoutPage';
import PaymentPage from './components/PaymentPage';
import PaypalPayment from './components/PaypalPayment';
import PaypalPaymentNotify from './components/PaypalPaymentNotify';
import SezzlePaymentNotify from './components/SezzlePaymentNotify';
import ThankyouPage from './components/ThankyouPage'; 
import LocalStorage from './components/LocalStorage'; 
import ConferencePay from './components/ConferencePay';
import CourseQuickPay from './components/CourseQuickPay';
import AbandonedPay from './components/AbandonedPay';
import MiscPay from './components/MiscPay';
import ReenrollPay from './components/ReenrollPay';
import MiscellaneousCharge from './components/MiscellaneousCharge';
import AdvancedCertificate from './components/AdvancedCertificate';
import SoccerAdvancedCertificate from './components/SoccerAdvancedCertificate';
import BaseballAdvancedCertificate from './components/BaseballAdvancedCertificate';
import BasketballAdvancedCertificate from './components/BasketballAdvancedCertificate';
import FootballAdvancedCertificate from './components/FootballAdvancedCertificate';
import HockeyAdvancedCertificate from './components/HockeyAdvancedCertificate';
import SportsAgentAdvancedCertificate from './components/SportsAgentAdvancedCertificate';
import Store from './components/Store';
import ApparelProductDetail from './components/ApparelProductDetail';
import ViewTab from './components/ViewTab';
import EditProfile from './components/EditProfile';
import CreditCardChange from './components/CreditCardChange';
import CancelledSubscriptionCreditCardChange from './components/CancelledSubscriptionCreditCardChange';
import SubscriptionUpdate from './components/SubscriptionUpdate';
import CancelledSubscriptionUpdate from './components/CancelledSubscriptionUpdate';
import OrderDetailsPage from './components/OrderDetailsPage';
import ForgetPassword from './components/ForgetPassword';
import VerifyPassword from './components/VerifyPassword';
import Logout from './components/Logout';
import SubscriptionEdit from './components/SubscriptionEdit';
import AddToEarena from './components/AddToEarena';
import AddAthlete from './components/AddAthlete';
import AgentDirectory from './components/AgentDirectory';
import ScoutDirectory from './components/ScoutDirectory';
import ManageEmails from './components/ManageEmails';
import ManagePeople from './components/ManagePeople';
import ManageAdminPeople from './components/ManageAdminPeople';
import AppList from './components/AppList';
import AddUser from './components/AddUser';
import EventlogMore from './components/EventlogMore';
import ScheduleTaskMore from './components/ScheduleTaskMore';
import MySalesTasks from './components/MySalesTasks';
import ManageEmailsEdit from './components/ManageEmailsEdit';
import ViewEmail from './components/ViewEmail';
import ViewAthlete from './components/ViewAthlete';
import SalespersonCreateApplication from './components/SalespersonCreateApplication';
import ApplicationImporter from './components/ApplicationImporter';
import RolodexImporter from './components/RolodexImporter';
import ManageSortflag from './components/ManageSortflag';
import SortflagUsers from './components/SortflagUsers';
import PendingAthletes from './components/PendingAthletes';
import CourseCodeKey from './components/CourseCodeKey';
import DraftDivvy from './components/DraftDivvy';
import ViewScoutingRequests from './components/ViewScoutingRequests';
import AddSortflag from './components/AddSortflag';
import EditSortflag from './components/EditSortflag';
import ViewSortflag from './components/ViewSortflag';
import EditAgentMessage from './components/EditAgentMessage';
import EditScoutMessage from './components/EditScoutMessage';
import ManageScoutingReportsEdit from './components/ManageScoutingReportsEdit';
import ManageAgents from './components/ManageAgents';
import ManageAthletes from './components/ManageAthletes';
import ManageAgentMessage from './components/ManageAgentMessage';
import CreateAgentMessage from './components/CreateAgentMessage';
import ManageScoutMessage from './components/ManageScoutMessage';
import CreateScoutMessage from './components/CreateScoutMessage';
import ManageScoutingReports from './components/ManageScoutingReports';
import AgentBio from './components/AgentBio';
import ScoutBio from './components/ScoutBio';
import AthleteBio from './components/AthleteBio';
import AppsByCountry from './components/AppsByCountry';
import PaymentsReport from './components/PaymentsReport';
import CancelledPaymentsReport from './components/CancelledPaymentsReport';
import SortFlagReport from './components/SortFlagReport';
import UserAdvanceSearch from './components/UserAdvanceSearch';
import ReferralWalletReport from './components/ReferralWalletReport';
import PaymentsComparisonReport from './components/PaymentsComparisonReport';
import SalesReportBySortflag from './components/SalesReportBySortflag';
import SuspendedPaymentReport from './components/SuspendedPaymentReport';
import SalespersonActivityReport from './components/SalespersonActivityReport';
import SalesReportByProduct from './components/SalesReportByProduct';
import SalesandAppsReport from './components/SalesandAppsReport';
import ReferrerLog from './components/ReferrerLog';
import ResourceLibrary from './components/ResourceLibrary';
import ResourceLibraryEdit from './components/ResourceLibraryEdit';
import ResourceLibraryCreate from './components/ResourceLibraryCreate';
import ManageGlobalAmbassadors from './components/ManageGlobalAmbassadors';
import ManageReferrals from './components/ManageReferrals';
import ManageOrders from './components/ManageOrders';
import ManageProducts from './components/ManageProducts';
import AddNewProduct from './components/AddNewProduct';
import EditProduct from './components/EditProduct';
import CashOut from './components/CashOut';
import ApparelOrderItemList from './components/ApparelOrderItemList';
import ChangeApparelOrderStatus from './components/ChangeApparelOrderStatus';
import ApparelOrderStatusLog from './components/ApparelOrderStatusLog';
import ManageCategories from './components/ManageCategories';
import CreateProductCategory from './components/CreateProductCategory';
import EditProductCategory from './components/EditProductCategory';
import FlatShippingRates from './components/FlatShippingRates';
import CouponList from './components/CouponList';
import CreateCoupon from './components/CreateCoupon';
import EditCoupon from './components/EditCoupon';
import DeleteCoupon from './components/DeleteCoupon';
import DiscountList from './components/DiscountList';
import CreateNewDiscount from './components/CreateNewDiscount';
import EditDiscount from './components/EditDiscount';
import DeleteDiscount from './components/DeleteDiscount';
import ConferenceRegistrationReport from './components/ConferenceRegistrationReport';
import ScoutAgentAthleteExport from './components/ScoutAgentAthleteExport';
import ListAmbassador from './components/ListAmbassador';
import ListContinentAmbassador from './components/ListContinentAmbassador';
import AmbassadorBio from './components/AmbassadorBio';
import DeleteProduct from './components/DeleteProduct';
import PackageList from './components/PackageList';
import EditProductPackage from './components/EditProductPackage';
import DeleteProductPackage from './components/DeleteProductPackage';
import CreateProductPackage from './components/CreateProductPackage';
import AgentMyAccount from './components/AgentMyAccount';
import ManageMyAthletes from './components/ManageMyAthletes';
import AgentHome from './components/AgentHome';
import CreateScoutReport from './components/CreateScoutReport';
import ScoutMyReports from './components/ScoutMyReports';
import ScoutMyAccount from './components/ScoutMyAccount';
import MyScoutRequestReports from './components/MyScoutRequestReports';
import ViewScoutingRequestsScout from './components/ViewScoutingRequestsScout';
import ScoutRequestReportView from './components/ScoutRequestReportView';
import ScoutingRequestsFrom from './components/ScoutingRequestsForm';
import SportsEducationProgram from './components/SportsEducationProgram';
import ScoutMainHome from './components/ScoutMainHome';
import ContinentsScouts from './components/ContinentsScouts';
import ApprovalProfileChanges from './components/ApprovalProfileChanges';
import LookingForAgent from './components/LookingForAgent';
import BasketballEducationProgram from './components/BasketballEducationProgram';
import CricketEducationProgram from './components/CricketEducationProgram';
import FootballEducationProgram from './components/FootballEducationProgram';
import HockeyEducationProgram from './components/HockeyEducationProgram';
import RugbyEducationProgram from './components/RugbyEducationProgram';
import SoccerEducationProgram from './components/SoccerEducationProgram';
import AgencyMainHome from './components/AgencyMainHome';
import CanadaScoutList from './components/CanadaScoutList';
import CanadaStateScoutList from './components/CanadaStateScoutList';
import ScoutsMap from './components/ScoutsMap';
import ListScoutSports from './components/ListScoutSports';
import ListContinentScoutSports from './components/ListContinentScoutSports';
import AllScouts from './components/AllScouts';
import USScoutList from './components/USScoutList';
import USStateScoutList from './components/USStateScoutList';
import ContactUs from './components/ContactUs'
import AgentsMap from './components/AgentsMap';
import AgencyWebsiteandCommunications from './components/AgencyWebsiteandCommunications';
import AgencyFinancialServices from './components/AgencyFinancialServices';
import ContinentsAgents from './components/ContinentsAgents';
import CanadaAgentList from './components/CanadaAgentList';
import CanadaStateAgentList from './components/CanadaStateAgentList';
import USAgentList from './components/USAgentList';
import USStateAgentList from './components/USStateAgentList';
import AllAgents from './components/AllAgents';
import SportSpecificAgent from './components/SportSpecificAgent';
import BaseballAgency from './components/BaseballAgency';
import BasketballAgency from './components/BasketballAgency';
import CricketAgency from './components/CricketAgency';
import FootballAgency from './components/FootballAgency';
import HockeyAgency from './components/HockeyAgency';
import RacingAgency from './components/RacingAgency';
import RugbyAgency from './components/RugbyAgency';
import SoccerAgency from './components/SoccerAgency';
import AgencyEndorsements from './components/AgencyEndorsements';
import AgencyMissionandVision from './components/AgencyMissionandVision';
import AgencySMWWDifference from './components/AgencySMWWDifference';
import AgencyPostCareerPlanning from './components/AgencyPostCareerPlanning';
import AgencyMarketing from './components/AgencyMarketing';
import LookingForAgentView from './components/LookingForAgentView';
import ManageLookingforAthleteSubmissions from './components/ManageLookingforAthleteSubmissions';
import AthleteRequestApproval from './components/AthleteRequestApproval';
import AgencyNewsList from './components/AgencyNewsList';
import AddBlogPost from './components/AddBlogPost';
import AgencyNewsContent from './components/AgencyNewsContent';
import ManageBlogPost from './components/ManageBlogPost';
import EditBlog from './components/EditBlog';
import MyCredentialsDetailView from './components/MyCredentialsDetailView';
import JensCastenTestimonial from './components/JensCastenTestimonial';
import SteveWisensalephdTestimonial from './components/SteveWisensalephdTestimonial';
import DavidSauriolTestimonial from './components/DavidSauriolTestimonial';
import MikeAblettTestimonial from './components/MikeAblettTestimonial';
import EditOrderInfoPage from './components/EditOrderInfoPage';
import ManageRequestScoutReportSubmissions from './components/ManageRequestScoutReportSubmissions';
import ScoutRequestReportEdit from './components/ScoutRequestReportEdit';
import LookingForAgentEdit from './components/LookingForAgentEdit';
import ScoutRequestWebformResult from './components/ScoutRequestWebformResult';
import LookingForAgentWebformResults from './components/LookingForAgentWebformResults';
import CheckoutOrderLog from './components/CheckoutOrderLog';
import ManageDocTalks from './components/ManageDocTalks';
import AddDocTalk from './components/AddDocTalk';
import EditDocTalk from './components/EditDocTalk';
import ViewDocTalk from './components/ViewDocTalk';
import PixelTracker from './components/PixelTracker';
import ReactPixel from 'react-facebook-pixel';

const currentDomain = window.location.host.replace(/^https?:\/\//, '');
const agencydomains = [
  configData.RSMWW_AGENCY_DOMAIN,
  configData.RSMWW_AGENCY_DOMAIN1
];
const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("uid")
  );
   useEffect(() => {
  const host = window.location.hostname;

  let favicon = "/favicon.ico";
  let appleIcon = "/favicon.png";

  if (agencydomains.some(domain => host.includes(domain))) {
    favicon = "/agency_favicon.ico";
    appleIcon = "/agency_favicon.png";
  }

  // Update favicon
  const faviconLink = document.querySelector("link[rel='icon']");
  if (faviconLink) {
    faviconLink.href = favicon + "?v=" + Date.now();
  }

  // Update apple touch icon
  const appleLink = document.querySelector("link[rel='apple-touch-icon']");
  if (appleLink) {
    appleLink.href = appleIcon + "?v=" + Date.now();
  }
  // Logout sync across tabs
  const syncLogout = (event) => {
    if (event.key === "logout" || event.key === "uid") {

      const uid = localStorage.getItem("uid");

     if (!uid) {
                // update auth state only
                setIsLoggedIn(false);
            }
    }
  };

  window.addEventListener("storage", syncLogout);

  return () => {
    window.removeEventListener("storage", syncLogout);
  };

}, []);
useEffect(() => {
    ReactPixel.init(configData.FB_PIXEDL_ID);
   
  }, []);
  return (
    <AuthProvider>

    <Router>
      <div>
        <PixelTracker />
        <Header />
        <Routes>
          <Route path="/" element={
    currentDomain.includes(configData.RSMWW_SCOUT_DOMAIN) || currentDomain.includes(configData.RSMWW_SCOUT_DOMAIN1) || currentDomain.includes(configData.RSMWW_SCOUT_DOMAIN2)  ? (
      <ScoutMainHome />
    ) : currentDomain.includes(configData.RSMWW_AGENCY_DOMAIN) || currentDomain.includes(configData.RSMWW_AGENCY_DOMAIN1) ? (
            <AgencyMainHome />
          ) : (
      <></> // Default, render nothing
    )
  } 
/>
           <Route path="/agencyhome" element={<AgencyMainHome />} />
           <Route path="/scouthome" element={<ScoutMainHome />} />
          <Route path="/user" element={<Login />} />
          <Route path="/agency/login" element={<AgencyLogin />} />
          <Route path="/smww/cart" element={<CartApp />} />
          <Route path="/post/:id" element={<Post />} />
          <Route path="/application" element={<ApplicationForm />} /> 
          <Route path="/form" element={<Form />} />
          <Route path="/request-more-info" element={<RequestForm />} />
          <Route path="/talk-with-dr-lynn-lashbrook" element={<TalkwithLynn />} />
          <Route path='/smww_pay' element={<CoursePay />} />
          <Route path='/smww/checkout' element={<CheckoutPage />} />
		      <Route path='/smww/checkout/cart' element={<PaymentPage />} />
          <Route path='/smww/checkout/paypal' element={<PaypalPayment />} />
          <Route path='/smww/checkout/paypal/notify' element={<PaypalPaymentNotify />} />
          <Route path='/smww/checkout/sezzle/confirm' element={<SezzlePaymentNotify />} />
		      <Route path='/smww/checkout/thankyou/:order_id' element={<ThankyouPage />} />
          <Route path='/smww/get/userorder' element={<LocalStorage />} />
          <Route path='/smww_conference_pay' element={<ConferencePay />} />
          <Route path='/smww_course_pay' element={<CourseQuickPay />} />
          <Route path='/smww_abandoned_pay' element={<AbandonedPay />} />
          <Route path='/smww_misc_pay' element={<MiscPay />} />
          <Route path='/smww_reenroll_pay' element={<ReenrollPay />} />
          <Route path='/miscellaneous/charge/:uid' element={<MiscellaneousCharge />} />
          <Route path='/advanced_certificates' element={<AdvancedCertificate />} />
          <Route path='/soccer-advanced-certificate' element={<SoccerAdvancedCertificate />} />
          <Route path='/baseball-advanced-certificate' element={<BaseballAdvancedCertificate />} />
          <Route path='/basketball-advanced-certificate' element={<BasketballAdvancedCertificate />} />
          <Route path='/football-advanced-certificate' element={<FootballAdvancedCertificate />} />
          <Route path='/hockey-advanced-certificate' element={<HockeyAdvancedCertificate />} />
          <Route path='/sports-agent-advanced-certificate' element={<SportsAgentAdvancedCertificate />} />
          <Route path='/store' element={<Store />} />
          <Route path='/store/:slug' element={<ApparelProductDetail />} />
          <Route path='/user/:uid' element={<ViewTab />} />
          <Route path='/users/:username' element={<ViewTab />} />
          <Route path='/user/:uid/:tab' element={<ViewTab />} />
          <Route path='/subscription/card/change/:subscription_id' element={<CreditCardChange />} />
          <Route path='/cancelled_subscription/card/change/:subscription_id' element={<CancelledSubscriptionCreditCardChange />} />
          <Route path='/subscription/update/:subscription_id' element={<SubscriptionUpdate /> } />
          <Route path='/cancelled_subscription/update/:subscription_id' element={<CancelledSubscriptionUpdate /> } />
          <Route path='/subscription/edit-status/:subscription_id/:id' element={<SubscriptionEdit /> } />
          <Route path='/user/:uid/smww_orders/:order_id' element={<OrderDetailsPage /> } />
          <Route path='/user/password' element={<ForgetPassword /> } />
          <Route path='/user/verify_password' element={<VerifyPassword /> } />
          <Route path='/user/logout' element={<Logout /> } />
          <Route path='/add_to_earena/:uid' element={<AddToEarena /> } />
          <Route path='/agency_home' element={<AgentHome /> } />
          <Route path='/scouting-requests' element={<ScoutingRequestsFrom /> } />
          <Route path='/lookingforagent.php' element={<LookingForAgent /> } />
          
          <Route path='/sports/education/baseball' element={<SportsEducationProgram /> } />
		      <Route path='/sports/education/basketball' element={<BasketballEducationProgram /> } />
          <Route path='/sports/education/cricket' element={<CricketEducationProgram/> } />
          <Route path='/sports/education/football' element={<FootballEducationProgram/> } />
          <Route path='/sports/education/rugby' element={<RugbyEducationProgram/> } />
          <Route path='/sports/education/soccer' element={<SoccerEducationProgram/> } />
          <Route path='/sports/education/hockey' element={<HockeyEducationProgram /> } />

          <Route path='/testimonial/jens-casten' element={<JensCastenTestimonial /> } />
          <Route path='/testimonial/steve-wisensale-phd' element={<SteveWisensalephdTestimonial /> } />
          <Route path='/testimonial/david-sauriol' element={<DavidSauriolTestimonial /> } />
          <Route path='/testimonial/mike-ablett' element={<MikeAblettTestimonial /> } />

          <Route path='/agent/:slug' element={<AgentBio /> } />
          <Route path='/scout/:slug' element={<ScoutBio /> } />
          <Route path='/athlete/:slug' element={<AthleteBio /> } />
          
          {/*
          <Route path='/program/global-ambassadors' element={<ListAmbassador /> } />
          <Route path='/continents/:continentid/ambassadors' element={<ListContinentAmbassador /> } />
          <Route path='/ambassador/:slug' element={<AmbassadorBio /> } />
          */}
          <Route path='/continents/:continentid/scouts' element={<ContinentsScouts /> } />
          <Route path='/sports-scout-canada-map' element={<CanadaScoutList /> } />
          <Route path='/sports-scout-canada-map/:state' element={<CanadaStateScoutList /> } />
          <Route path='/sports_scouts_map' element={<ScoutsMap /> } />
           <Route path='/scout-sports/:sports' element={<ListScoutSports /> } />
          <Route path='/scout-sports/:sports/:continentid' element={<ListContinentScoutSports /> } />
          <Route path='/scouts' element={<AllScouts /> } />
           <Route path='/sports_scouts_usmap' element={<USScoutList /> } />
          <Route path='/sports_scouts_usmap/:sports' element={<USScoutList /> } />
          <Route path='/sports_scouts_usmap/:sports/:state' element={<USStateScoutList /> } />
          <Route path='/contact' element={<ContactUs /> } />
          <Route path='/sports_agents_map' element={<AgentsMap /> } />
           <Route path='/website-and-new-media-communications' element={<AgencyWebsiteandCommunications /> } />
           <Route path='/financial-services' element={<AgencyFinancialServices /> } />
          <Route path='/continents/:continentid/agents' element={<ContinentsAgents /> } />
          <Route path='/sports_agent_canada_map' element={<CanadaAgentList /> } />
          <Route path='/sports_agent_canada_map/:state' element={<CanadaStateAgentList /> } />
          <Route path='/sports_agents_usmap' element={<USAgentList /> } />
          <Route path='/sports_agents_usmap/:sports' element={<USAgentList /> } />
          <Route path='/state/:state/agents' element={<USStateAgentList /> } />
          <Route path='/agents' element={<AllAgents /> } />
           <Route path='/agents/:sport' element={<SportSpecificAgent /> } />
          <Route path='/sports/baseball' element={<BaseballAgency/> } />
          <Route path='/sports/basketball' element={<BasketballAgency/> } />
          <Route path='/sports/cricket' element={<CricketAgency/> } />
          <Route path='/sports/football' element={<FootballAgency/> } />
          <Route path='/sports/hockey' element={<HockeyAgency/> } />
          <Route path='/sports/racing' element={<RacingAgency/> } />
          <Route path='/sports/rugby' element={<RugbyAgency/> } />
          <Route path='/sports/soccer' element={<SoccerAgency/> } />
          <Route path='/content/marketing' element={<AgencyMarketing /> } />
          <Route path='/sports/basketball/endorsements' element={<AgencyEndorsements /> } />
          <Route path='/content/smww-difference' element={<AgencySMWWDifference /> } />
          <Route path='/our-mission-and-values' element={<AgencyMissionandVision /> } />
          <Route path='/sports/basketball/post_career_planning' element={<AgencyPostCareerPlanning /> } />
          <Route path='/smww-agency-news' element={< AgencyNewsList /> } />
          <Route path='/blog-content/:slug' element={< AgencyNewsContent /> } />
           <Route path='/certificate/:slug/:drupal_uid/course/:sku/:classid' element={<MyCredentialsDetailView />} />
          
         <Route path='/node/add/blog'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
           <AddBlogPost />
          </ProtectedRoute>
          }/>
           <Route path='/blog-content/:id/edit'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
           <EditBlog />
          </ProtectedRoute>
          }/>
           <Route path='/user/:uid/edit_order/:order_id'  element={
          <ProtectedRoute roles={['administrator','sales people','SAAdmin']}>
           <EditOrderInfoPage />
          </ProtectedRoute>
          }/>
          <Route path='manage-blog'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
           <ManageBlogPost />
          </ProtectedRoute>
          }/>
          
           <Route path='/node/1080/submission/:id'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','agent']}>
           <LookingForAgentView />
          </ProtectedRoute>
          }/>
           <Route path='/node/1080/submissions'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','agent']}>
           <ManageLookingforAthleteSubmissions />
          </ProtectedRoute>
          }/>
          <Route path='/node/841/submissions'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','scout']}>
           <ManageRequestScoutReportSubmissions />
          </ProtectedRoute>
          }/>
          <Route path='/athlete/requestapproval/:drupal_uid'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','agent']}>
           <AthleteRequestApproval />
          </ProtectedRoute>
          }/>
           <Route path='/add_athlete'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people','agent']}>
           <AddAthlete />
          </ProtectedRoute>
          }/>
           <Route path='/agents-directory'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people','agent']}>
           <AgentDirectory />
          </ProtectedRoute>
          }/>
          <Route path='/scouts-directory'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people','scout']}>
           <ScoutDirectory />
          </ProtectedRoute>
          }/>
           <Route path='/manage-emails'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <ManageEmails />
          </ProtectedRoute>
          }/>
          <Route path='/saadmin-people'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <ManagePeople />
          </ProtectedRoute>
          }/>
           <Route path='/manage/people'  element={
          <ProtectedRoute roles={['administrator']}>
            <ManageAdminPeople />
          </ProtectedRoute>
          }/>
          <Route path='/app-list'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <AppList />
          </ProtectedRoute>
          }/>
          <Route path='/admin/people/create'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <AddUser />
          </ProtectedRoute>
          }/>
          <Route path='/salesperson/create/application'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <SalespersonCreateApplication />
          </ProtectedRoute>
          }/>
          <Route path='/eventlog/more/:uid' element={<EventlogMore /> } />
          <Route path='/moretasks/:uid' element={<ScheduleTaskMore /> } />
         
         <Route path='/my_sales_tasks'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <MySalesTasks />
          </ProtectedRoute>
          }/>
          <Route path='/emails/:id/:tab'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <ViewEmail />
          </ProtectedRoute>
          }/>
         <Route path='/view_athlete/:drupal_uid' element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people', 'agent']}>
            <ViewAthlete /></ProtectedRoute>
          } />
          <Route path='/importer/application'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <ApplicationImporter />
          </ProtectedRoute>
          }/>
           <Route path='/importer/rolodex'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <RolodexImporter />
          </ProtectedRoute>
          }/>
          <Route path='/draft-divvy'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <DraftDivvy />
          </ProtectedRoute>
          }/>
          <Route path='/sortflags'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <ManageSortflag />
          </ProtectedRoute>
          }/>
          <Route path='/sort-flag-users/:tid'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <SortflagUsers />
          </ProtectedRoute>
          }/>
        
          
          <Route path='/course_code_key'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <CourseCodeKey />
          </ProtectedRoute>
          }/>
           <Route path='/pending_athletes'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','sales people','agent']}>
            <PendingAthletes />
          </ProtectedRoute>
          }/>
          <Route path='/pending_athletes/:id'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','sales people','agent']}>
            <PendingAthletes />
          </ProtectedRoute>
          }/>
          
         

         <Route path='/view/scouting-requests'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <ViewScoutingRequests />
          </ProtectedRoute>
          }/>
          <Route path='/manage-doc-talk-mentors'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            <ManageDocTalks />
          </ProtectedRoute>
          }/>
           <Route path='/node/add/doc-talk-mentors'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            <AddDocTalk />
          </ProtectedRoute>
          }/>
          <Route path='/node/add/doc-talk-mentors'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            <AddDocTalk />
          </ProtectedRoute>
          }/>
          <Route path='/doc-talk-mentors/:nid/:tab'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            <EditDocTalk />
          </ProtectedRoute>
          }/>
          <Route path='/admin/smww-commerce/product-edit/:id'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            <EditProduct />
          </ProtectedRoute>
          }/>
          <Route path='/admin/smww-commerce/product-delete/:id'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            <DeleteProduct />
          </ProtectedRoute>
          }/>
          
           <Route path='/admin/structure/taxonomy/sort_flags/add'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            <AddSortflag />
          </ProtectedRoute>
          
          }/>
         
          <Route path='/taxonomy/term/:tid/:tab'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            <ViewSortflag />
          </ProtectedRoute>
          
          }/>
         <Route path='/manage-agents'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
            <ManageAgents />
          </ProtectedRoute>
          }/>
          <Route path='/manage-athletes'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
            <ManageAthletes />
          </ProtectedRoute>
          }/>
           <Route path='/saadmin/manage-agent-message'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
            <ManageAgentMessage />
          </ProtectedRoute>
          }/>
           <Route path='/node/add/agent-message'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
            <CreateAgentMessage />
          </ProtectedRoute>
          }/>
          
          <Route path='/agent-message/:aid/:tab'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','agent']}>
            <EditAgentMessage />
          </ProtectedRoute>
          
          }/>
           <Route path='/saadmin/manage-scout-message'  element={
          <ProtectedRoute  roles={['administrator','SAAdmin']}>
            <ManageScoutMessage />
          </ProtectedRoute>
          }/>
           <Route path='/node/add/scout-message'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
            <CreateScoutMessage />
          </ProtectedRoute>
          }/>
          
          <Route path='/scout-message/:aid/:tab'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','scout']}>
            <EditScoutMessage />
          </ProtectedRoute>
          
          }/>
           <Route path='/manage-scouting-reports'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            <ManageScoutingReports />
          </ProtectedRoute>
          
          }/>
          <Route path='/scout-report/:rid/:tab'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','scout']}>
            <ManageScoutingReportsEdit />
          </ProtectedRoute>
          
          }/>
           <Route path='/admin/reports/apps_by_country'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <AppsByCountry />
          </ProtectedRoute>
          }/>
         <Route path='/admin/reports/courses-payments'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <PaymentsReport />
          </ProtectedRoute>
          }/>
           <Route path='/subscription/payment/cancelled'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <CancelledPaymentsReport />
          </ProtectedRoute>
          }/>
           <Route path='/admin/reports/sort_flag'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <SortFlagReport />
          </ProtectedRoute>
          }/>
           <Route path='/user-advance-search'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <UserAdvanceSearch />
          </ProtectedRoute>
          }/>
        
        <Route path='/admin/reports/refererrer_bonus'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <ReferralWalletReport />
          </ProtectedRoute>
          }/>
         <Route path='/admin/reports/sales_details_new'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <PaymentsComparisonReport />
          </ProtectedRoute>
          }/>
           <Route path='/admin/reports/sales_report_by_sortflag'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
            <SalesReportBySortflag />
          </ProtectedRoute>
          }/>
           <Route path='/admin/reports/suspended_payment'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
            <SuspendedPaymentReport />
          </ProtectedRoute>
          }/>
          <Route path='/admin/reports/event_log'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','sales people']}>
            <SalespersonActivityReport />
          </ProtectedRoute>
          }/>
         <Route path='/admin/reports/sales_report_by_product'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
            <SalesReportByProduct />
          </ProtectedRoute>
          }/>
           <Route path='/admin/reports/weekly_sales_report'  element={
          <ProtectedRoute roles={['administrator']}>
            <SalesandAppsReport />
          </ProtectedRoute>
          }/>
          <Route path='/smww/referral/log/:drupaluid'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
            <ReferrerLog />
          </ProtectedRoute>
          }/>
          <Route path='/resource_library'  element={
          <ProtectedRoute roles={['administrator','SAAdmin','agent','scout']}>
            <ResourceLibrary />
          </ProtectedRoute>
          }/>
          <Route path='/resource_library/:rid/:tab'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','agent','scout']}>
            <ResourceLibraryEdit />
          </ProtectedRoute>
          
          }/>
           <Route path='/node/add/resource-library'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ResourceLibraryCreate />
          </ProtectedRoute>
          
          }/>
           <Route path='/manage-global-ambassadors'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ManageGlobalAmbassadors />
          </ProtectedRoute>
          
          }/>
       <Route path='/manage-referrals'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ManageReferrals />
          </ProtectedRoute>
          
          }/>
           <Route path='/admin/smww-commerce/order-list'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ManageOrders />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/product-list'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ManageProducts />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/product-create'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < AddNewProduct />
          </ProtectedRoute>
          
          }/> 
           <Route path='/smww/referral/cashout/:drupal_uid'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < CashOut />
          </ProtectedRoute>
          
          }/> 
          <Route path='/apparel-order-list'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ApparelOrderItemList />
          </ProtectedRoute>
          
          }/> 
          <Route path='/change-apparel-order-status/:order_status'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ChangeApparelOrderStatus />
          </ProtectedRoute>
          
          }/> 
          <Route path='/apparel-order-status-log'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ApparelOrderStatusLog />
          </ProtectedRoute>
          
          }/> 
          <Route path='/checkout-order-log'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < CheckoutOrderLog />
          </ProtectedRoute>
          
          }/> 
          
          <Route path='/admin/smww-commerce/product-categories-list'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ManageCategories />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/product-categories-create'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < CreateProductCategory />
          </ProtectedRoute>
          
          }/> 
           <Route path='/admin/smww-commerce/product-categories-edit/:id'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < EditProductCategory />
          </ProtectedRoute>
          
          }/> 
       <Route path='/add-shipping-rates'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < FlatShippingRates />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/coupon-list'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < CouponList />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/coupon-create'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < CreateCoupon />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/coupon-edit/:id'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < EditCoupon />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/coupon-delete/:id'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < DeleteCoupon />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/discount-list'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < DiscountList />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/discount-create'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < CreateNewDiscount />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/discount-edit/:id'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < EditDiscount />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/discount-delete/:id'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < DeleteDiscount />
          </ProtectedRoute>
          
          }/> 
          <Route path='/conference-registration'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ConferenceRegistrationReport />
          </ProtectedRoute>
          
          }/> 
        <Route path='/admin/reports/agent_athlete_scout'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ScoutAgentAthleteExport />
          </ProtectedRoute>
          
          }/> 
        <Route path='/admin/smww-commerce/product-package-list'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < PackageList />
          </ProtectedRoute>
          
          }/> 
           <Route path='/admin/smww-commerce/product-package-edit/:id'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < EditProductPackage />
          </ProtectedRoute>
          
          }/> 
          <Route path='/admin/smww-commerce/product-package-delete/:id'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < DeleteProductPackage />
          </ProtectedRoute>
          
          }/> 
           <Route path='/admin/smww-commerce/product-package-create'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < CreateProductPackage />
          </ProtectedRoute>
          
          }/> 
        <Route path='/my_agents_account'  element={
           <ProtectedRoute roles={['agent','administrator']}>
            < AgentMyAccount />
          </ProtectedRoute>
          
          }/>
        <Route path='/my_athletes'  element={
           <ProtectedRoute roles={['agent','administrator']}>
            < ManageMyAthletes />
          </ProtectedRoute>
          
          }/>
            <Route path='/node/add/scout-report'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','scout']}>
            < CreateScoutReport />
          </ProtectedRoute>
          
          }/>
          <Route path='/my_reports'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','scout']}>
            < ScoutMyReports />
          </ProtectedRoute>
          
          }/>
          <Route path='/my_scouts_account'  element={
           <ProtectedRoute roles={['scout','administrator']}>
            < ScoutMyAccount />
          </ProtectedRoute>
          
          }/>
          <Route path='/my_scout_request_reports'  element={
           <ProtectedRoute roles={['scout','administrator']}>
            < MyScoutRequestReports />
          </ProtectedRoute>
          
          }/>
           <Route path='/admin/reports/scouting_request'  element={
           <ProtectedRoute roles={['scout','administrator']}>
            < ViewScoutingRequestsScout />
          </ProtectedRoute>
          
          }/>
          <Route path='/node/841/submission/:sid'  element={
           <ProtectedRoute roles={['administrator','SAAdmin','scout']}>
            < ScoutRequestReportView />
          </ProtectedRoute>
          
          }/>
          <Route path='/admin/config/content/profile-approval'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ApprovalProfileChanges />
          </ProtectedRoute>
          
          }/>
           <Route path='/node/841/submission/:sid/:tab'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ScoutRequestReportEdit />
          </ProtectedRoute>
          
          }/>
          <Route path='/node/841/webform-results'  element={
           <ProtectedRoute roles={['administrator','SAAdmin']}>
            < ScoutRequestWebformResult />
          </ProtectedRoute>
          
          }/>
          <Route path='/node/1080/submission/:id/:tab'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
           <LookingForAgentEdit />
          </ProtectedRoute>
          }/>
          <Route path='/node/1080/webform-results'  element={
          <ProtectedRoute roles={['administrator','SAAdmin']}>
           <LookingForAgentWebformResults />
          </ProtectedRoute>
          }/>          
        </Routes>


        
        <Footer />
      </div>
    </Router>
     </AuthProvider>
  );
}
 
export default App;